// Показателите на „По станции".
//
// Сторното идва от друг ендпойнт, зад друго право (`view_voids`). Няма ли го,
// кутийката просто липсва — „0.00 € сторно" при непрочетени данни е измислица,
// не факт.

import { useTranslation } from "react-i18next";

import { fmtEuro } from "../../../../utils/currency";
import { ReportKpiCard } from "../ReportKpiCard";
import { deltaPercent } from "../reportDelta";
import type { StationsTotals } from "./stationsMath";

/** Минус знак U+2212 — сторното е отнета сума. */
const MINUS = "−";

type Props = {
  totals: StationsTotals;
  /** Оборотът на предходния период; `null` = сравнението е изключено. */
  previousRevenue: number | null;
  /** Сторното на предходния период; `null` = няма сравнение или няма право. */
  previousVoidTotal: number | null;
  showVoids: boolean;
  isNarrow: boolean;
};

export const StationsKpis = ({
  totals,
  previousRevenue,
  previousVoidTotal,
  showVoids,
  isNarrow,
}: Props) => {
  const { t } = useTranslation();

  return (
    // Класовете са ЦЕЛИ литерали: Tailwind сканира изходния текст и не вижда
    // име, сглобено с template literal.
    <div
      className={`grid gap-2.5 ${
        isNarrow
          ? "grid-cols-2"
          : showVoids
            ? "grid-cols-2 lg:grid-cols-[1.4fr_1fr_1.2fr]"
            : "grid-cols-2 lg:grid-cols-[1.4fr_1fr]"
      }`}
    >
      <ReportKpiCard
        kicker={t("reportsPage.stationsRevenueKpi")}
        value={fmtEuro(totals.revenue)}
        sub={t("reportsPage.stationsRevenueKpiSub")}
        delta={
          previousRevenue === null
            ? undefined
            : deltaPercent(totals.revenue, previousRevenue)
        }
        hero
      />

      <ReportKpiCard
        kicker={t("reportsPage.stationsCountKpi")}
        value={String(totals.stations)}
        sub={t("reportsPage.stationsCountKpiSub")}
      />

      {showVoids ? (
        <ReportKpiCard
          kicker={t("reportsPage.stationsVoidsKpi")}
          value={
            totals.voidTotal > 0
              ? `${MINUS}${fmtEuro(totals.voidTotal)}`
              : fmtEuro(0)
          }
          sub={t("reportsPage.stationsVoidsCount", { count: totals.voidRows })}
          delta={
            previousVoidTotal === null
              ? undefined
              : deltaPercent(totals.voidTotal, previousVoidTotal)
          }
          invertDelta
          hot={totals.voidTotal > 0}
        />
      ) : null}
    </div>
  );
};
